// NOSONAR_BEGIN
// import { supportedBrowsersRegex } from "./generatedSupportedBrowsersRegex";

export function isBrowserSupported() {
    // DISABLED FOR NOW UNTIL TESTING ENVIRONMENTS CAN BE UPDATED
    return true;
    // try {
    //     if (typeof navigator !== "undefined" && navigator.userAgent) {
    //         return supportedBrowsersRegex.test(navigator.userAgent);
    //     }
    // } catch {
    //     return true; // Assume support if check fails
    // }
    // return true; // Default to supported if no navigator
}
// NOSONAR_END
